// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ghost__container___GXS4Y {
    position: relative;
    width: 0;

    &.Ghost__hide___HcJC_ {
        translate: -9999rem;
        transition: 0.1s;
    }

    .Ghost__count___j2npH {
        --font-size: var(--size-text-2xs);
        --padding: var(--space-3xs);
        --size: calc(var(--font-size) + 2 * var(--padding));

        position: absolute;
        z-index: 4;
        transform: translateX(-50%) translateY(-50%);

        width: var(--size);
        padding: var(--space-3xs);

        font-size: var(--font-size);
        line-height: 1;
        color: white;
        text-align: center;

        background-color: var(--color-bg-success);
        border-radius: 50%;
    }
}

.Ghost__ghost___fQRHM {
    --step: 0.5rem;
    --offset: calc(var(--step) * var(--index));
    --opacity: calc((var(--max-index) - var(--index)) / (var(--max-index)));

    position: absolute;

    /* z-index тут локальный для этого компонента и нужен, для создания глубины при стеке объектов */
    z-index: calc(-1 * var(--index));
    transform: translateX(var(--offset)) translateY(var(--offset));

    display: inline-flex;
    gap: 0.8rem;
    align-items: center;

    padding: 0.2rem 0.8rem 0.2rem 0.4rem;

    opacity: var(--opacity);
    background-color: var(--color-control-bg-primary);
    border-radius: 0.4rem;

    .Ghost__iconContainer___YnLqk {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: center;

        width: 1.6rem;
        height: 1.6rem;
        padding: 0.2rem;

        background-color: var(--color-bg-default);
        border-radius: 0.4rem;
    }

    .Ghost__text___5cTj6 {
        color: white;
        text-wrap: nowrap;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Ghost/Ghost.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;;IAER;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,2BAA2B;QAC3B,mDAAmD;;QAEnD,kBAAkB;QAClB,UAAU;QACV,4CAA4C;;QAE5C,kBAAkB;QAClB,yBAAyB;;QAEzB,2BAA2B;QAC3B,cAAc;QACd,YAAY;QACZ,kBAAkB;;QAElB,yCAAyC;QACzC,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,uEAAuE;;IAEvE,kBAAkB;;IAElB,gGAAgG;IAChG,gCAAgC;IAChC,8DAA8D;;IAE9D,oBAAoB;IACpB,WAAW;IACX,mBAAmB;;IAEnB,oCAAoC;;IAEpC,uBAAuB;IACvB,iDAAiD;IACjD,qBAAqB;;IAErB;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,uBAAuB;;QAEvB,aAAa;QACb,cAAc;QACd,eAAe;;QAEf,yCAAyC;QACzC,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".container {\n    position: relative;\n    width: 0;\n\n    &.hide {\n        translate: -9999rem;\n        transition: 0.1s;\n    }\n\n    .count {\n        --font-size: var(--size-text-2xs);\n        --padding: var(--space-3xs);\n        --size: calc(var(--font-size) + 2 * var(--padding));\n\n        position: absolute;\n        z-index: 4;\n        transform: translateX(-50%) translateY(-50%);\n\n        width: var(--size);\n        padding: var(--space-3xs);\n\n        font-size: var(--font-size);\n        line-height: 1;\n        color: white;\n        text-align: center;\n\n        background-color: var(--color-bg-success);\n        border-radius: 50%;\n    }\n}\n\n.ghost {\n    --step: 0.5rem;\n    --offset: calc(var(--step) * var(--index));\n    --opacity: calc((var(--max-index) - var(--index)) / (var(--max-index)));\n\n    position: absolute;\n\n    /* z-index тут локальный для этого компонента и нужен, для создания глубины при стеке объектов */\n    z-index: calc(-1 * var(--index));\n    transform: translateX(var(--offset)) translateY(var(--offset));\n\n    display: inline-flex;\n    gap: 0.8rem;\n    align-items: center;\n\n    padding: 0.2rem 0.8rem 0.2rem 0.4rem;\n\n    opacity: var(--opacity);\n    background-color: var(--color-control-bg-primary);\n    border-radius: 0.4rem;\n\n    .iconContainer {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n        justify-content: center;\n\n        width: 1.6rem;\n        height: 1.6rem;\n        padding: 0.2rem;\n\n        background-color: var(--color-bg-default);\n        border-radius: 0.4rem;\n    }\n\n    .text {\n        color: white;\n        text-wrap: nowrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ghost__container___GXS4Y`,
	"hide": `Ghost__hide___HcJC_`,
	"count": `Ghost__count___j2npH`,
	"ghost": `Ghost__ghost___fQRHM`,
	"iconContainer": `Ghost__iconContainer___YnLqk`,
	"text": `Ghost__text___5cTj6`
};
export default ___CSS_LOADER_EXPORT___;
